<app-main-header></app-main-header>
<div class="content">
    @if (isAdmin$ | async) {
        <div style="display: flex; justify-content: flex-end; margin: 0.5rem 2.5rem 0 0;">
            <button pButton type="button" label="Create Restriction" icon="pi pi-plus" (click)="showDialog = true" class="add-restriction-button"></button>
        </div>
    }

    <app-restriction-dialog [(visible)]="showDialog" (onSave)="handleSave($event)"></app-restriction-dialog>

    <app-vehicles-table></app-vehicles-table>
</div>
